module.exports = __webpack_public_path__ + "static/10-170932cd33b680fbdb9292720d0539b3.png";